import {takeEvery} from 'redux-saga/effects'
import {
  ADD_EXAM_TYPE_LABEL,
  DELETE_MANY_EXAM_TYPE_LABELS,
  DELETE_SINGLE_EXAM_TYPE_LABEL,
  GET_EXAM_TYPE_LABELS,
  UPDATE_EXAM_TYPE_LABEL,
  VIEW_SELECTED_EXAM_TYPE_LABEL,
} from 'setup/redux/Actions/ExamTypeLabels/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(ADD_EXAM_TYPE_LABEL, fetchData)
  yield takeEvery(DELETE_MANY_EXAM_TYPE_LABELS, fetchData)
  yield takeEvery(DELETE_SINGLE_EXAM_TYPE_LABEL, fetchData)
  yield takeEvery(GET_EXAM_TYPE_LABELS, fetchData)
  yield takeEvery(UPDATE_EXAM_TYPE_LABEL, fetchData)
  yield takeEvery(VIEW_SELECTED_EXAM_TYPE_LABEL, fetchData)
}

export default dataSaga
